import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  templateActions,
  templateSelectors
} from '../../../store/modules/template';

export const useFetchTemplates = () => {
  const dispatch = useDispatch();
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);

  useEffect(() => {
    dispatch(
      templateActions.fetchTemplateListByFilter({
        category: currentTemplate?.category.toString()
      })
    );

    return () => {
      dispatch(templateActions.resetTemplateList());
    };
  }, []);

  return currentTemplate?.templateId;
};
